export default (superClass) => {
    return class extends superClass {
        get openingHours() {
            return {
                monday: this.getOpeningHoursString('monday'),
                tuesday: this.getOpeningHoursString('tuesday'),
                wednesday: this.getOpeningHoursString('wednesday'),
                thursday: this.getOpeningHoursString('thursday'),
                friday: this.getOpeningHoursString('friday'),
                saturday: this.getOpeningHoursString('saturday'),
                sunday: this.getOpeningHoursString('sunday')
            }
        }

        getOpeningHoursString(weekday) {
            let open = (this._data[`opening_hours_${weekday}_open`] || '').trim();
            let close = (this._data[`opening_hours_${weekday}_close`] || '').trim();

            if(open.length == 0 || close.length == 0) {
                return false;
            }

            if(!open.includes(':')) {
                open += ':00';
            }

            if(!close.includes(':')) {
                close += ':00';
            }

            return `${open} - ${close}`;
        }
    }
}